import { render } from "./VAside.vue?vue&type=template&id=ffa8cab2&scoped=true"
import script from "./VAside.vue?vue&type=script&lang=js"
export * from "./VAside.vue?vue&type=script&lang=js"

import "./VAside.vue?vue&type=style&index=0&id=ffa8cab2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffa8cab2"]])

export default __exports__